import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Accordion,
  Badge,
  Label,
  Input,
  Row,
  Col,
  Button,
  Container,
  Spinner,
} from "reactstrap";
import "./App.css";
import { HBApi } from "./HBApi";
import { dateString, withCustomEndTimeHoursDateString } from "./HBApi";
import { BerthFunctions } from "./BerthFunctions";
import { useAuth } from "./AuthContext";
import DatePicker from "react-datepicker";
const MyHarbour = () => {
  const navigate = useNavigate();
  const auth = useAuth();

  let MILLIS_PER_DAY = 86400000;
  const [myBerths, setMyBerths] = useState([]);
  const [futureBookings, setFutureBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [futureStatuses, setFutureStatuses] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [customArrival, setCustomArrival] = useState("12");
  const [refresh, setRefresh] = useState(0);
  var today = new Date();
  var maxDate = new Date(today.getTime() + 150 * MILLIS_PER_DAY);

  const [open, setOpen] = useState("0");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  useEffect(() => {
    console.log("Enter useEffect");
    setLoading(true);
    HBApi.getMyBerths()
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then((data) => {
        if (!data[0]) {
          setLoading(false);
          return;
        } else {
          console.log("My harbour received berths: " + JSON.stringify(data));
          setMyBerths(data);
          HBApi.getBookingsByBerth(data[0].id, today, maxDate)
            .then((bookings) => {
              console.log("Received bookings: " + JSON.stringify(bookings));
              setFutureBookings(bookings);
              HBApi.getBerthStatusesByBerth(
                data[0].id,
                new Date(),
                new Date()
              ).then((statusesJson) => {
                console.log(
                  "Received berth statuses: " + JSON.stringify(statusesJson)
                );
                setFutureStatuses(statusesJson);
              });
            })
            .then(() => setLoading(false));
        }
      })
      .catch((errorResponse) => {
        console.log("errorResponse" + errorResponse.status);
        if (errorResponse.status === 401) {
          // If the server has restarted, this will happen
          console.log(
            "Unexpected 401 response, this will happen if the server has restarted"
          );
          auth.userLogout();
          navigate("/signin", { state: { nextpage: "/mypage/myberth" } });
        }
      });
  }, [refresh]);

  const highlightWithRanges = [
    {
      "react-datepicker__day--highlighted-custom-1":
        BerthFunctions.bookedDays(futureBookings),
    },
    {
      "react-datepicker__day--highlighted-custom-2":
        BerthFunctions.statusDaysExcludingBookedDays(
          futureStatuses,
          futureBookings
        ),
    },
  ];

  const onDateChange = (dates) => {
    const [start, end] = dates;
    console.log("Enter onDateChange with start: " + start + " and end: " + end);
    if (end && start.getTime() === end.getTime()) {
      console.log("Start date = end date");
      return;
    }
    setStartDate(start);
    setEndDate(end);
  };

  const StatusDates = () => {
    let hld = highlightWithRanges;
    return (
      <DatePicker
        minDate={new Date()}
        maxDate={maxDate}
        onChange={onDateChange}
        highlightDates={hld}
        selectsRange={true}
        startDate={startDate}
        endDate={endDate}
        inline
        selectsDisabledDaysInRange={false}
      />
    );
  };

  const StatusCol = ({ berth }) => {
    if (!berth.enabled) {
      return (
        <Col>
          <Badge>Disabled</Badge>
        </Col>
      );
    } else if (berth.enabled && berth.available) {
      return (
        <Col>
          <Badge>Currently Available</Badge>
        </Col>
      );
    } else {
      return (
        <Col>
          <Badge>Currently Booked</Badge>
        </Col>
      );
    }
  };

  const FutureBookingCount = ({ berth }) => {
    return (
      <Col>
        <Badge>
          Future booked days: {BerthFunctions.bookedDays(futureBookings).length}
        </Badge>
      </Col>
    );
  };

  const statusLabel = (berth) => {
    if (berth.defaultStatus === 0) {
      return "Future enabled days: ";
    } else {
      return "Future disabled days: ";
    }
  };
  const FutureEnabledCount = ({ berth }) => {
    return (
      <Col>
        <Badge>
          {statusLabel(berth)}
          {BerthFunctions.statusDays(futureStatuses).length}
        </Badge>
      </Col>
    );
  };

  const BookingsStatusesAccordion = () => {
    return (
      <Accordion open={open} toggle={toggle}>
        <AccordionItem>
          <AccordionHeader targetId="1">
            <b>Future booking details</b>
          </AccordionHeader>
          <AccordionBody accordionId="1">
            <BookingsList />
          </AccordionBody>
        </AccordionItem>
        <AccordionItem>
          <AccordionHeader targetId="2">
            <b>Future statuses</b>
          </AccordionHeader>
          <AccordionBody accordionId="2">
            <StatusesList />
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    );
  };

  const BookingsList = () => {
    return futureBookings.map((b) => (
      <Row key={b.id}>
        <Col>
          <b>Booking:</b>{" "}
        </Col>
        <Col> from: {withCustomEndTimeHoursDateString(b.from)} </Col>
        <Col> to: {withCustomEndTimeHoursDateString(b.to)} </Col>
        <Col> booked at {dateString(b.createdAt)} </Col>
        <Col> Cancellable: {b.cancellable ? "yes" : "no"} </Col>
      </Row>
    ));
  };

  const StatusesList = () => {
    return futureStatuses.map((st) => (
      <Row key={st.id}>
        <Col>
          <b>{st.status === 1 ? "Bookable period" : "Non bookable period"}</b>{" "}
        </Col>
        <Col> from: {withCustomEndTimeHoursDateString(st.from)} </Col>
        <Col> to: {withCustomEndTimeHoursDateString(st.to)} </Col>
        <Col>
          <Button onClick={() => deleteStatus({ target: { id: st.id } })}>
            X
          </Button>
        </Col>
        <Col />
      </Row>
    ));
  };

  const NoBerth = () => {
    return (
      <Container>
        <Row>
          <Col md="12">
            <h1 align="center">No berth</h1>
          </Col>
        </Row>
      </Container>
    );
  };

  const handleCustomArrival = async (event) => {
    const { name, value } = event.target;
    setCustomArrival(value);
  };

  const calculateEndDate = () => {
    let rv = new Date(endDate.getTime() + (customArrival - 12) * 3600000);
    return rv;
  };

  const deleteStatus = (event) => {
    console.log(`deleteStatus with ${JSON.stringify(event.target)}`);
    HBApi.deleteBerthStatus({ id: event.target.id })
      .then((response) => {
        if (response.status.ok) {
          return response.json();
        }
      })
      .then((jsonResponse) => setRefresh(refresh + 1));
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    console.log(
      `Submit make available request with start date ${startDate} and end date ${endDate} (hours: ${endDate.getHours()}) and custom arrival ${customArrival}`
    );
    HBApi.modifyBerthStatus({
      berth: myBerths[0].id,
      berthStatus: "1",
      from: startDate,
      to: endDate,
      customArrival: customArrival,
    })
      .then((response) => {
        console.log(`Got response: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        console.log(`Modify statuses respons: ${JSON.stringify(data)}`);
        let newFutureStatuses = [...futureStatuses, data[0]];
        console.log(
          `New future statuses: ${JSON.stringify(newFutureStatuses)}`
        );
        setRefresh(refresh + 1);
      });
  };

  const MakeAvailableButton = () => {
    if (
      endDate &&
      BerthFunctions.atLeastOneDayChangesStatusToEnabled(
        startDate,
        endDate,
        futureStatuses,
        futureBookings
      )
    ) {
      return (
        <Button
          id="makeAvailableButtonId"
          size="lg"
          color="primary"
          onClick={handleSubmit.bind(this)}
        >
          Make available
        </Button>
      );
    } else {
      return (
        <Button size="lg" color="primary" disabled>
          Make available
        </Button>
      );
    }
  };

  const CustomHours = () => {
    return Array.from({ length: 10 }, (value, index) => index + 12).map(
      (actualHour) => {
        return (
          <option key={actualHour} value={actualHour}>
            {actualHour}
          </option>
        );
      }
    );
  };
  const CustomArrival = () => {
    return (
      <div>
        <Label for="customarrival">Custom arrival time</Label>
        <Input
          value={customArrival}
          id="customarrival"
          bssize="md"
          type="select"
          name="customarrival"
          onChange={handleCustomArrival}
        >
          <CustomHours />
        </Input>
      </div>
    );
  };

  const DefaultStatus = () => {
    if (myBerths[0].defaultStatus === 0) {
      return <Badge color="warning">Disabled</Badge>;
    } else {
      return <Badge>Enabled</Badge>;
    }
  };

  if (loading) {
    return <Spinner />;
  }

  if (myBerths.length === 0) {
    return <NoBerth />;
  } else {
    return (
      <Container>
        <Row>
          <Col md="12">
            <h3 align="center">Berth Details</h3>
          </Col>
        </Row>
        <Row>
          <Col id="berthLabelId">Berth: {myBerths[0].label}</Col>
          <Col>
            Default status: <DefaultStatus />
          </Col>
          <Col />
          <Col />
        </Row>
        <Row>
          <Col id="maxLengthId">Max length: {myBerths[0].maxLength}</Col>
          <Col>Max width: {myBerths[0].maxWidth}</Col>
          <Col>Max depth: {myBerths[0].maxDepth}</Col>
          <Col>Fixation type: {myBerths[0].fixationTypeLabel}</Col>
        </Row>
        <Row>
          <StatusCol berth={myBerths[0]} />
          <FutureBookingCount berth={myBerths[0]} />
          <FutureEnabledCount berth={myBerths[0]} />
          <Col />
        </Row>

        <Row>
          <BookingsStatusesAccordion />
        </Row>
        <Row>
          <Col />
          <Col>
            <StatusDates />
          </Col>
          <Col>
            <CustomArrival />
          </Col>
        </Row>
        <Row>
          <Col />
          <Col>
            <MakeAvailableButton />
          </Col>
          <Col />
        </Row>
      </Container>
    );
  }
};

export default MyHarbour;
